/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './checkSignupQueue.defs.js'
export * as $defs from './checkSignupQueue.defs.js'
